type IdLike = { _id?: string; id?: string };
type SubLike = { sub?: string; _id?: string; id?: string };

const isIdLike = (input: unknown): input is IdLike =>
  typeof input === 'object' && input !== null && ('_id' in input || 'id' in input);

const extractId = (input: string | IdLike): string | undefined => {
  if (typeof input === 'string') {
    return input;
  }

  if (input._id) {
    return input._id;
  }

  if (input.id) {
    return input.id;
  }

  return undefined;
};

export const normalizeToIds = (value: string | IdLike | Array<string | IdLike> | undefined): string[] => {
  if (!value) {
    return [];
  }

  const list = Array.isArray(value) ? value : [value];

  const ids = list
    .map((item) => (isIdLike(item) || typeof item === 'string' ? extractId(item) : undefined))
    .filter((id): id is string => typeof id === 'string' && id.length > 0);

  return Array.from(new Set(ids));
};

export const normalizeToSubs = (value: string | SubLike | Array<string | SubLike> | undefined): string[] => {
  if (!value) {
    return [];
  }

  const list = Array.isArray(value) ? value : [value];

  const subs = list
    .map((item) => {
      if (typeof item === 'string') {
        return item;
      }
      if (item.sub) {
        return item.sub;
      }
      if (item._id) {
        return item._id;
      }
      if (item.id) {
        return item.id;
      }
      return undefined;
    })
    .filter((sub): sub is string => typeof sub === 'string' && sub.length > 0);

  return Array.from(new Set(subs));
};
